/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export const GetApiV3NodeProvidersNodeProviderIdNodesIncludeStatus = {
  Down: "DOWN",
  Up: "UP",
  Unassigned: "UNASSIGNED",
  Disabled: "DISABLED",
  Degraded: "DEGRADED",
} as const;
export type GetApiV3NodeProvidersNodeProviderIdNodesIncludeStatus = ClosedEnum<
  typeof GetApiV3NodeProvidersNodeProviderIdNodesIncludeStatus
>;

export type GetApiV3NodeProvidersNodeProviderIdNodesRequest = {
  /**
   * Node Statuses
   */
  includeStatus?:
    | Array<GetApiV3NodeProvidersNodeProviderIdNodesIncludeStatus>
    | undefined;
  /**
   * Node Provider ID
   */
  nodeProviderId: string;
};

/** @internal */
export const GetApiV3NodeProvidersNodeProviderIdNodesIncludeStatus$inboundSchema:
  z.ZodNativeEnum<
    typeof GetApiV3NodeProvidersNodeProviderIdNodesIncludeStatus
  > = z.nativeEnum(GetApiV3NodeProvidersNodeProviderIdNodesIncludeStatus);

/** @internal */
export const GetApiV3NodeProvidersNodeProviderIdNodesIncludeStatus$outboundSchema:
  z.ZodNativeEnum<
    typeof GetApiV3NodeProvidersNodeProviderIdNodesIncludeStatus
  > = GetApiV3NodeProvidersNodeProviderIdNodesIncludeStatus$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3NodeProvidersNodeProviderIdNodesIncludeStatus$ {
  /** @deprecated use `GetApiV3NodeProvidersNodeProviderIdNodesIncludeStatus$inboundSchema` instead. */
  export const inboundSchema =
    GetApiV3NodeProvidersNodeProviderIdNodesIncludeStatus$inboundSchema;
  /** @deprecated use `GetApiV3NodeProvidersNodeProviderIdNodesIncludeStatus$outboundSchema` instead. */
  export const outboundSchema =
    GetApiV3NodeProvidersNodeProviderIdNodesIncludeStatus$outboundSchema;
}

/** @internal */
export const GetApiV3NodeProvidersNodeProviderIdNodesRequest$inboundSchema:
  z.ZodType<
    GetApiV3NodeProvidersNodeProviderIdNodesRequest,
    z.ZodTypeDef,
    unknown
  > = z.object({
    include_status: z.array(
      GetApiV3NodeProvidersNodeProviderIdNodesIncludeStatus$inboundSchema,
    ).optional(),
    node_provider_id: z.string(),
  }).transform((v) => {
    return remap$(v, {
      "include_status": "includeStatus",
      "node_provider_id": "nodeProviderId",
    });
  });

/** @internal */
export type GetApiV3NodeProvidersNodeProviderIdNodesRequest$Outbound = {
  include_status?: Array<string> | undefined;
  node_provider_id: string;
};

/** @internal */
export const GetApiV3NodeProvidersNodeProviderIdNodesRequest$outboundSchema:
  z.ZodType<
    GetApiV3NodeProvidersNodeProviderIdNodesRequest$Outbound,
    z.ZodTypeDef,
    GetApiV3NodeProvidersNodeProviderIdNodesRequest
  > = z.object({
    includeStatus: z.array(
      GetApiV3NodeProvidersNodeProviderIdNodesIncludeStatus$outboundSchema,
    ).optional(),
    nodeProviderId: z.string(),
  }).transform((v) => {
    return remap$(v, {
      includeStatus: "include_status",
      nodeProviderId: "node_provider_id",
    });
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3NodeProvidersNodeProviderIdNodesRequest$ {
  /** @deprecated use `GetApiV3NodeProvidersNodeProviderIdNodesRequest$inboundSchema` instead. */
  export const inboundSchema =
    GetApiV3NodeProvidersNodeProviderIdNodesRequest$inboundSchema;
  /** @deprecated use `GetApiV3NodeProvidersNodeProviderIdNodesRequest$outboundSchema` instead. */
  export const outboundSchema =
    GetApiV3NodeProvidersNodeProviderIdNodesRequest$outboundSchema;
  /** @deprecated use `GetApiV3NodeProvidersNodeProviderIdNodesRequest$Outbound` instead. */
  export type Outbound =
    GetApiV3NodeProvidersNodeProviderIdNodesRequest$Outbound;
}

export function getApiV3NodeProvidersNodeProviderIdNodesRequestToJSON(
  getApiV3NodeProvidersNodeProviderIdNodesRequest:
    GetApiV3NodeProvidersNodeProviderIdNodesRequest,
): string {
  return JSON.stringify(
    GetApiV3NodeProvidersNodeProviderIdNodesRequest$outboundSchema.parse(
      getApiV3NodeProvidersNodeProviderIdNodesRequest,
    ),
  );
}

export function getApiV3NodeProvidersNodeProviderIdNodesRequestFromJSON(
  jsonString: string,
): SafeParseResult<
  GetApiV3NodeProvidersNodeProviderIdNodesRequest,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      GetApiV3NodeProvidersNodeProviderIdNodesRequest$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'GetApiV3NodeProvidersNodeProviderIdNodesRequest' from JSON`,
  );
}
